export default __webpack_public_path__ + "static/media/Xerox.daffa2d5.png";